import { tryParseJSON } from "@eventr/common";
import { Stack } from "@mui/material";
import { useMemo } from "react";
import { cardTranslation } from "i18n/translateHelpers";
import { CardText } from "../subComponents/cardText";
import { RowInfoFiles } from "../subComponents/rowInfoFiles";
import { RowInfoNotes } from "../subComponents/rowInfoNotes";
interface ActivityPersonalItemsProps {
  documents?: string;
  notes?: string;
}

export const ActivityPersonalItems = ({ documents, notes }: ActivityPersonalItemsProps) => {
  const files = useMemo(() => {
    if (!documents) return [];
    return tryParseJSON(documents, []) as string[];
  }, [documents]);

  if (!files.length && !notes) return null;
  return (
    <Stack spacing="8px">
      <CardText variant="bodyBold">{cardTranslation("Personal Items")}</CardText>

      {notes && <RowInfoNotes notes={notes} />}
      {files && <RowInfoFiles files={files} />}
    </Stack>
  );
};
